import { useEffect, useSyncExternalStore } from 'react';
import { client, getLogin, subscribe, session, updateFromMe, clearLogin, type LoginInfo } from './session';

export function useLogin(): LoginInfo | null {
  return useSyncExternalStore(subscribe, getLogin, getLogin);
}

/** Background token refresh + `/me` every 2 minutes (401 → sign out), while signed in. */
export function useSessionKeepAlive(active: boolean, intervalMs = 2 * 60 * 1000): void {
  useEffect(() => {
    if (!active) return;
    const stop = session.startAutoRefresh();
    let alive = true;
    const check = async () => {
      if (!session.peek()) return;
      try {
        const me = await client.me();
        if (alive) updateFromMe(me);
      } catch (e) {
        const status = (e as { status?: number }).status;
        if (status === 401 || status === 403) clearLogin();
      }
    };
    void check();
    const id = setInterval(check, intervalMs);
    return () => {
      alive = false;
      stop();
      clearInterval(id);
    };
  }, [active, intervalMs]);
}
